import Vue from 'vue';
// import VueTouch from 'vue-touch';
import ELF from '@hb/elf';
import FastClick from 'fastclick';
// import $ from 'zepto'; // eslint-disable-line
import TIANQI_UBT from '@/utils/tianqiUBT';
import ubtPlugin from '@/plugin/ubt';
import TcpPlugin from '@/plugin/Tcp';
import App from './App';
import router from './router';
import authStore from './store/auth';
import { setConst, setSysTag, getSysTag } from './const/app.const';
import imageViewer from './utils/image-viewer';
import './styles/reset-mint-ui.less';
import './utils/crow';

Vue.config.productionTip = false;

// 初始化基础状态
authStore.init();


FastClick.attach(document.body);
// 解决高版本iOS输入框多次点击才能聚焦问题，原因是与fastClick聚焦冲突，但是启用后iOS输入框第一次点击不会自动滚动到键盘上方的问题会暴露
FastClick.prototype.focus = (targetElement) => {
  let length;
  if (targetElement.setSelectionRange && targetElement.type.indexOf('date') !== 0 && targetElement.type.indexOf('number') !== 0 && targetElement.type !== 'time' && targetElement.type !== 'month') {
    length = targetElement.value.length;
    targetElement.focus();
    targetElement.setSelectionRange(length, length);
  } else {
    targetElement.focus();
  }
};

// 解决PhFeUIH5组件库夸克节点ios点击无效问题，解决方式：保留原生点击事件
const oldNeedsClick = FastClick.prototype.needsClick;
FastClick.prototype.needsClick = (target) => {
  // 只加了这个if 判断 quark 组件的逻辑，其它的逻辑同源码
  if (target.nodeName.toLowerCase().indexOf('quark-') !== -1) {
    return true;
  }
  return oldNeedsClick(target);
};

// 初始化环境切换
// 非生产 && 非dev && 非预渲染，才加载elf和vconsole
if (process.env.VUE_APP_ENV !== 'pro' && !window.__PRERENDER_INJECTED) {
  // eslint-disable-next-line camelcase
  const __elf_env = String(window.localStorage.getItem('__elf_env')).replace(/"/g, '');
  const __sysTag = getSysTag();
  // eslint-disable-next-line camelcase
  if (__elf_env && __elf_env !== 'null') {
    setConst(__elf_env);
  }
  new ELF({
    envConfig: ['dev', 'fat', 'fat_2', 'uat', 'gray', 'pre', 'pro', `__sysTag bate0.1 ==>  ${__sysTag || ''}`],
    // eslint-disable-next-line camelcase
    currentEnv: __elf_env && __elf_env !== 'null' ? __elf_env : '',
  }).on('envChanged', (e) => {
    if (e.data && e.data.indexOf('__sysTag') !== -1) {
      // eslint-disable-next-line no-alert
      const newSysTag = prompt('输入你的sysTag', '');
      setSysTag(newSysTag);
      setTimeout(() => {
        // 去掉默认的elf的默认赋值
        // eslint-disable-next-line camelcase
        window.localStorage.setItem('__elf_env', `"${__elf_env}"`);
        window.location.reload();
      });
      return;
    }
    setConst(e.data);
    TIANQI_UBT.initConfig();
    // eslint-disable-next-line camelcase
    if (e.data !== __elf_env) {
      window.location.reload();
    }
  });

  // 加载vconsole
  const scriptElement = document.createElement('script');
  scriptElement.setAttribute('src', 'https://m.hellobike.com/resource/h5/hitch/js/vconsole.min.js');
  document.head.appendChild(scriptElement);
  // eslint-disable-next-line
  scriptElement.onload = () => { new VConsole(); };
}

TIANQI_UBT.initConfig();
// 手势库，包装了hammerjs的指令，参考 https://github.com/vuejs/vue-touch/tree/next
// Vue.use(VueTouch, {name: 'v-touch'});

// 天启埋点插件，包含自动化pv/pvout 和 挂载全局埋点方法
Vue.use(ubtPlugin);
Vue.use(new TcpPlugin());
Vue.use(imageViewer);
export default new Vue({
  el: '#app',
  router,
  render: (h) => h(App),
});
